export default [
  {
    header: 'База <Фильмы>',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Фильмы',
    route: 'movies',
    icon: 'FilmIcon',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Премьеры',
    route: 'movies-premiers',
    icon: 'StarIcon',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Топ фильмов',
    route: 'movies-top',
    icon: 'ArrowUpCircleIcon',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Фильтр фильмов',
    route: 'movies-filter',
    icon: 'FilterIcon',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Поиск фильмов',
    route: 'movies-search',
    icon: 'SearchIcon',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Импорт из Кинопаба',
    route: 'movies-kinopub',
    icon: 'CameraIcon',
    resource: 'db-movies',
    action: 'view',
  },
  {
    title: 'Импорт Коллекций КП',
    route: 'movies-collections',
    icon: 'LayersIcon',
    resource: 'db-movies',
    action: 'view',
  },
]
